// NPM Imports
import { useState } from 'react'
// Quote Context
// Component Imports
// JS Imports
// Asset Imports

export default function QuoteAccordion({
   accordionName,
   accordionBodyId,
   collapse,
   children,
}) {
   const [accordionCollapse, setAccordionCollapse] = useState(collapse)

   const handleToggle = () => {
      setAccordionCollapse(accordionCollapse === 'true' ? 'collapsed' : 'true')
   }

   return (
      <div className='accordion accordion-bhr1' id='toolbarAccordion'>
         <div className='accordion-item'>
            <h2 className='accordion-header'>
               <button
                  className={
                     'accordion-button ' +
                     (accordionCollapse == 'true' ? 'collapsed' : '')
                  }
                  type='button'
                  data-bs-toggle='collapse'
                  data-bs-target={'#' + accordionBodyId}
                  aria-expanded='true'
                  aria-controls='panelsStayOpen-collapseOne'
                  onClick={handleToggle}
               >
                  <span>{accordionName}</span>
               </button>
            </h2>
            <div
               id={accordionBodyId}
               className={
                  'accordion-collapse collapse ' +
                  (accordionCollapse != 'true' ? 'show' : '')
               }
            >
               <div className='accordion-body'>{children}</div>
            </div>
         </div>
      </div>
   )
}
